import { MAX_TICKET_TITLE_CHARS, ticketTitleFromReport } from './tickets.js';
/**
 * Board notes (`docs/boardjs-plan.md` W2): what a developer types on their phone at the table, from
 * the game's library page, about the build their Board has. A note is an ordinary ticket, written by
 * the person in their own words, so it is the team's like any ticket the dashboard writes, not a
 * player's report: it takes no route, no migration and no desktop change.
 *
 * Two facts make it a note and not any ticket: the `board-note` tag, and the build it was about. The
 * build travels twice. As a line in the description, for a person reading it; and as a tag,
 * `build-<versionCode>`, because a list of tickets carries tags and not descriptions, and the
 * playground's Feedback window says beside each note whether a newer build is live.
 *
 * **It never names the Board.** A Board's name is its owner's alone (`CLAUDE.md`); a note is read by
 * the whole team, so it says which build, never whose Board.
 *
 * One implementation of the shape, here, because two places apply it: the note sheet, which writes
 * one, and the Feedback window, which reads them back.
 */
export const BOARD_NOTE_TAG = 'board-note';
const BUILD_TAG = /^build-(\d{1,9})$/;
export const BOARD_NOTE_WORDS_MAX = 2000;
export const BOARD_NOTE_SCREEN_MAX = 300;
/** The ticket a note becomes. Throws when there is nothing to say. */
export function boardNoteTicket(input) {
    const words = input.words.trim().slice(0, BOARD_NOTE_WORDS_MAX);
    if (!words)
        throw new Error('A note needs a few words about what happened.');
    const screen = (input.screen ?? '').trim().slice(0, BOARD_NOTE_SCREEN_MAX);
    const build = input.build ? `Seen on build ${input.build.label}, on a Board.` : 'Seen on a Board; the build was not known.';
    return {
        type: 'bug',
        title: ticketTitleFromReport(words).slice(0, MAX_TICKET_TITLE_CHARS),
        description: [build, words, screen ? `On screen: ${screen}` : ''].filter(Boolean).join('\n\n'),
        tags: [BOARD_NOTE_TAG, ...(input.build ? [`build-${input.build.versionCode}`] : [])],
    };
}
/** A ticket read back as a note: the build's version code, or null for a ticket that is not one. */
export function readBoardNote(ticket) {
    if (!ticket.tags.includes(BOARD_NOTE_TAG))
        return null;
    for (const tag of ticket.tags) {
        const match = BUILD_TAG.exec(tag);
        if (match)
            return { versionCode: Number(match[1]) };
    }
    return { versionCode: null };
}
//# sourceMappingURL=board-notes.js.map